export default "__VITE_ASSET__7$T600Yv__"